/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'trash-quiz',
  components: {},
  props: [],
  data () {
    return {
      quizData: {
        courseId: '',
      },
      QuizListDetails:null,
      courseId:'',
      removeQuizId:'',
      addquiz: null,
      isActive: false,
      is_active: false,

    }
  },
  computed: {
    ...mapGetters([
      'trashQuizDataState',
    ]),
    geQuizList() {
      this.$store.dispatch('trashQuizFun').then((res) => {
        this.QuizListDetails = this.$store.getters.trashQuizDataState.data
      }).catch((err) => {})
    },

  },
  mounted () {
    this.quizData.courseId = this.$route.params.courseId;
    this.courseId = this.$route.params.courseId;
    this.geQuizList
  },
  methods: { 
    geQuizListAgain() {
      this.$store.dispatch('trashQuizFun').then((res) => {
        this.QuizListDetails = this.$store.getters.trashQuizDataState.data
      }).catch((err) => {})
  },
  courseQuizStatusAct(quizId) {
    let data = {
      id: quizId
    }
    this.$store.dispatch('getQuizDetailsByIdFun', data)
      .then((res) => {
        if (res.data.code == '2000') {
          this.isActive = this.$store.getters.getQuizDetailsByIdDataState.is_active
          if (this.isActive === true) {
            this.is_active = false
          }
          if (this.isActive === false) {
            this.is_active = true
          }
          let data = {
            is_active: this.is_active,
          }
          this.$store.dispatch('updateQuizFun', {
            data: {
              data: data,
              id: quizId
            }
          }).then((res) => {
            if (res.status == '200') {
              this.geQuizListAgain();
              toast.success("Quiz Status Updated Successfully");
            }
          }).catch((err) => {})
          return
        }
      }).catch((err) => {})
  },
  removeQuizagain(id) {
    $('#removQuizModalAgain').modal();
    this.removeQuizId = id
  },
  RemoveQuizConfirmationagain(){
    let data = {
      is_deleted: false,
    }
    this.$store.dispatch('updateQuizFun', {
      data: {
        data: data,
        id:  this.removeQuizId
      }
    }).then((res) => {
      this.geQuizListAgain()
      toast.success("Quiz Restore Successfully");
    }).catch((err) => {})
  }
  }
}